<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">Contents</h2>
<p class="toc" id="ch1"><a href="#/text/9780062374295_Chapter_1#rch1">Sample Material</a></p>
<p class="toc3" id="ch2"><span href="#/text/9780062374295_Chapter_2#rch2" title="Link target outside of Sample">Teacher’s Guide</span></p>
<p class="toc1" id="ch2s1"><span href="#/text/9780062374295_Chapter_2#rch2s1" title="Link target outside of Sample">To the Teacher</span></p>
<p class="toc1" id="ch2s2"><span href="#/text/9780062374295_Chapter_3#rch2s2" title="Link target outside of Sample">Praise For John Irving’s <i>A Prayer For Owen Meany</i></span></p>
<p class="toc1" id="ch2s3"><span href="#/text/9780062374295_Chapter_4#rch2s3" title="Link target outside of Sample">About This Guide</span></p>
<p class="toc1" id="ch2s4"><span href="#/text/9780062374295_Chapter_5#rch2sa" title="Link target outside of Sample">Following and Understanding The Novel</span></p>
<p class="toc2" id="ch2s4-1"><span href="#/text/9780062374295_Chapter_5#rch2s4-1" title="Link target outside of Sample">Written Response</span></p>
<p class="toc2" id="ch2s4-2"><span href="#/text/9780062374295_Chapter_5#rch2s4-2" title="Link target outside of Sample">Questions for Class Discussion and Debate</span></p>
<p class="toc2" id="ch2s4-3"><span href="#/text/9780062374295_Chapter_5#rch2s4-3" title="Link target outside of Sample">Research and Essay Topics</span></p>
<p class="toc" id="ch3"><span href="#/text/9780062374295_Chapter_6#rch3" title="Link target outside of Sample">Notes on the Novel’s Secondary Characters</span></p>
<p class="toc3" id="buy"><span href="#/text/9780062374295_Buy_Book#rbuy" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc" id="ata"><span href="#/text/About_the_Author#rata" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc" id="cpy"><span href="#/text/9780062374295_Copyright#rcpy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc" id="atp"><span href="#/text/About_the_Publisher#ratp" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062374295_Contents.vue?2774edb2